import React from 'react'

export default function StartWhyMemberSection() {
    return (
        <>
            <section className="why-memeber-section" id="why-memeber-sectionr">
                <div className="row ">
                    <div className="container">
                        <div className="why-memeber-content-wrap">
                            <div className="title wow zoomIn">
                                <h2 className="white">Why Members <span className="red">Love Snapshot Videos</span></h2>
                            </div>
                            <div className="member-content-image">
                                <div className="why-memeber-box-wrap">
                                    <div className="box left wow fadeInLeft">
                                        <div className="box-image">
                                            <img src="./images/fun-and-engaging.png" />
                                        </div>
                                        <div className="box-text">
                                            <p><span>Fun and Engaging:</span> High-energy, professionally produced videos
                                                by Association Studios make staying informed enjoyable.</p>
                                        </div>
                                    </div>
                                    <div className="box center wow zoomIn">
                                        <div className="box-image">
                                            <img src="./images/perfect-length.png" />
                                        </div>
                                        <div className="box-text">
                                            <p><span>The Perfect Length:</span> At 90 seconds, Snapshot Videos hit the sweet
                                                spot—long enough to deliver key information, short enough to
                                                keep attention.</p>
                                        </div>
                                    </div>
                                    <div className="box right wow fadeInRight">
                                        <div className="box-image">
                                            <img src="./images/always-know.png" />
                                        </div>
                                        <div className="box-text">
                                            <p><span>Always in the Know:</span> Members stay up-to-date with the essential
                                                information they need, when
                                                they need it.</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="big-image wow zoomIn">
                        <div className="image">
                            <img src="./images/why-member-bottom-image.png" />
                        </div>
                        <p className="wow fadeInRight">Give your members the updates they’ll love with Snapshot Videos!</p>
                    </div>
                </div>
            </section>
        </>
    )
}
